export default "__VITE_ASSET__CCzmr_$u__"